
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.5 10A7.499 7.499 0 003.627 6.048l-.32-1.254a.833.833 0 10-1.614.412l.84 3.292a.834.834 0 001.001.604l3.267-.783a.833.833 0 00-.389-1.621l-1.435.344a5.83 5.83 0 111.413 7.54.833.833 0 00-1.033 1.308A7.426 7.426 0 0010 17.5a7.508 7.508 0 007.5-7.5zM4.168 12.52a.832.832 0 110 1.665.832.832 0 010-1.665zm-.833-2.5a.832.832 0 110 1.665.832.832 0 010-1.665z","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.411 6.855a.833.833 0 011.423.59v3.027l1.355 1.47a.832.832 0 11-1.225 1.129l-1.576-1.709a.832.832 0 01-.221-.565V7.445c0-.221.088-.433.244-.59z","fill":"#fff"}})])
          )
        }
      }
    